import { render } from "./ProgressLoader.vue?vue&type=template&id=672fb959"
import script from "./ProgressLoader.vue?vue&type=script&lang=js"
export * from "./ProgressLoader.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ewizyta/lekarz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__